<div class="chatbot-container">
  <div class="chatbot-icon" (click)="toggleChat()">
    <mat-icon>{{ isChatOpen ? "close" : "chat" }}</mat-icon>
  </div>
  <div class="chat-window" [class.open]="isChatOpen">
    <div class="chat-header">
      <span class="chat-header-title">
        <app-common-graphic [graphicId]="'slalom-bot'"></app-common-graphic>beta me&#64;slalom
        bot</span
      >
      <mat-icon class="close-icon" (click)="toggleChat()">close</mat-icon>
    </div>
    <div #chatBody class="chat-body">
      <div
        *ngFor="let message of messages; let i = index"
        class="message"
        [ngClass]="{
          'user-message': message.user === 'user',
          'bot-message': message.user === 'bot'
        }"
      >
        <span class="message-icon">
          <app-small-bio
            *ngIf="user && message.user === 'user'"
            [employee]="user"
            [inline]="true"
            [imageOnly]="true"
            [linkToProfile]="false"
          ></app-small-bio
          ><span *ngIf="message.user === 'bot'"
            ><app-common-graphic [graphicId]="'slalom-bot'"></app-common-graphic></span
        ></span>
        <div class="message-content">
          <span class="message-text" [innerHTML]="message.text"></span>
          <div class="sub-message">
            <span *ngIf="messages[i + 1]?.user !== message.user" class="message-time">{{
              message.time | date : "shortTime"
            }}</span>
            <div *ngIf="message.user === 'bot' && message.messageId" class="feedback-icons">
              <span
                class="feedback-label"
                [ngClass]="{ 'helpful': message.helpful === true }"
                (click)="submitFeedback(message, true)"
                >Helpful<mat-icon>{{
                  message.helpful === true ? "thumb_up" : "thumb_up_off_alt"
                }}</mat-icon></span
              >
              <span
                class="feedback-label"
                [ngClass]="{ 'not-helpful': message.helpful === false }"
                (click)="submitFeedback(message, false)"
                >Didn't Help<mat-icon>{{
                  message.helpful === false ? "thumb_down" : "thumb_down_off_alt"
                }}</mat-icon></span
              >
            </div>
          </div>
        </div>
      </div>
      <div *ngIf="isBotThinking" class="thinking-animation">
        <span class="dot"></span><span class="dot"></span><span class="dot"></span>
      </div>
    </div>
    <div class="chat-footer">
      <div class="input-wrapper">
        <input
          type="text"
          [(ngModel)]="userInput"
          placeholder="Send a message..."
          (keydown.enter)="sendMessage()"
        />
        <button
          (click)="sendMessage()"
          class="send-btn"
          [ngClass]="{
            'has-input': !!userInput
          }"
        >
          <mat-icon>send</mat-icon>
        </button>
      </div>
    </div>
  </div>
</div>
